import {
  DeleteOutlined,
  EllipsisOutlined,
  LinkOutlined,
} from '@ant-design/icons';
import { Dropdown } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import type Bundle from 'stores/Bundle';

import DrawerButton from '../DrawerButton';

export interface BundleOptionsMenuProps {
  bundle: Bundle;
}

function BundleOptionsMenu({ bundle }: BundleOptionsMenuProps) {
  const menuSeed = [
    {
      icon: <LinkOutlined />,
      label: 'Source Files',
      enabled: !!bundle.sourceURL,
      onClick: () => {
        window.open(bundle.sourceURL, '_blank');
      },
    },
    {
      icon: <DeleteOutlined />,
      label: 'Archive',
      enabled: true,
      onClick: () => bundle.parent?.archive(bundle.id),
    },
  ];

  const menuItems = menuSeed.map((s) => ({
    key: s.label,
    label: s.label,
    icon: s.icon,
    disabled: !s.enabled,
    onClick: s.onClick,
  }));

  return (
    <Dropdown
      disabled={bundle.loading}
      trigger={['click']}
      menu={{
        items: menuItems,
      }}
    >
      <DrawerButton>
        <EllipsisOutlined />
      </DrawerButton>
    </Dropdown>
  );
}

export default observer(BundleOptionsMenu);
